import React, { FC, memo } from 'react'
import s from '@components/ui/Rating/Rating.module.css'

export interface RatingProps {
  value: number
  light?: boolean
  small?: boolean
}

const Quantity: FC<RatingProps> = ({ value = 5, light, small }) => (
  <span className={s.stars + ' ' + (light ? s.light : '') + ' ' + (small ? s.small : '') + ' block py-space4 pb-0 md:pb-space4'} style={{ "--rating": value } as React.CSSProperties} aria-label="Rating of Remi Health"></span>
)

export default memo(Quantity)
